import { Button } from "@/components/ui/button"
import modalStyles from "../modals.module.scss"
import styles from "./styles.module.scss"
import { useAutoTranslation, useModalStore } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"
import { Modal } from "@/shared/types"
import { Controller } from "react-hook-form"
import { useCreateNoteWebUrl } from "@/features"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { TypographyH2 } from "@/components/ui/typography"
import { useEffect } from "react"

export const CreateContentWithWebUrlModal = () => {
  const { t } = useAutoTranslation()
  const { control, handleSubmit, errors } = useCreateNoteWebUrl()
  const handleClose = () => {
    useModalStore.getState().closeModal(Modal.CREATE_CONTENT_WITH_WEB_URL)
  }

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleClose()
      }
    }

    window.addEventListener("keydown", handleKeyPress)
    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [])

  return (
    <div className={modalStyles.backdrop} onClick={handleClose}>
      <div className={styles.wrapper}>
        <div className={styles.card} onClick={e => e.stopPropagation()}>
          <TypographyH2 className={styles.title}>
            {t(DISCOVERED_TRANSLATION_KEYS.CREATE_CONTENT_WITH_WEB_URL)}
          </TypographyH2>

          <form onSubmit={handleSubmit} className="flex w-[90%] flex-col gap-4">
            <Controller
              control={control}
              name="url"
              rules={{
                required: true,
                pattern: {
                  value:
                    /^https:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/.*)?$/,
                  message: t(DISCOVERED_TRANSLATION_KEYS.INVALID_URL),
                },
              }}
              render={({ field }) => (
                <div className="flex flex-col gap-2">
                  <Label htmlFor="create-content-with-web-url-url">
                    {t(
                      DISCOVERED_TRANSLATION_KEYS.LINK_TO_DOCUMENT_OR_ANY_WEB_PAGE
                    )}
                  </Label>
                  <Input
                    autoFocus
                    id="create-content-with-web-url-url"
                    value={field.value}
                    onChange={field.onChange}
                    aria-invalid={!!errors.url}
                    placeholder="https://example.com"
                  />
                </div>
              )}
            />
            <Button type="submit" className="w-full">
              {t(DISCOVERED_TRANSLATION_KEYS.CREATE)}
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
